import { useTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

export const BubbleStyles = () => {
    const theme = useTheme();
    return {
        "& .z-axis-description": {
            fontSize: "12px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: grey[800],
            paddingLeft: "12px",
            "& svg": {
                color: theme.palette.primary.light,
                fontSize: "16px",
                marginLeft: "4px"
            },
        },
        "& .z-axis-negative": {
            fontSize: "12px",
            color: grey[800],
            paddingLeft: "12px",
        },
        "& .infoIcon": {
            color: theme.palette.purpleCold.dark,
            fontWeight: "bold",
            fontSize: "14px",
        },
        "& .axisLabel": {
            fontWeight: "bold",
            fontSize: "12px",
            paddingRight: "4px",
        },
        "& .noData": {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            height: "100%",
            fontWeight: "bold",
            background: " #efefef",
            minHeight: "200px"
        },
        "& .zAxis-tools": {
            alignItems: "center",
            display: {
                md: "flex",
            },
            padding: "0 16px",
            "& .control-labels": {
                marginRight: "2px",
            },
            "& label .MuiFormControlLabel-label": {
                fontSize: "14px",
            },
            "& .bubbleSize-container": {
                display: "flex",
                alignItems: "center",
                width: "380px",
                marginTop: {
                    xs: "10px",
                    md: "0",
                },
                marginLeft: { md: "auto" },
                paddingRight: "16px",
            },
            "& .bubbleSize__label": {
                fontSize: "12px",
            }
        },
    }
}